export default __webpack_public_path__ + "static/media/automotive-plant.4b540d82.svg";